export const text = {
    PREFIX: {
        WATCHLIST_ITEM: 'WatchlistItem',
    },
};
